<i18n
  src="@/locales/views/packing_house/quality_reports/process/list_templates.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_template.yml" lang="yaml"></i18n>

<template>

  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ph_quality_reports_process_list_processes_path"
    :params="{
      packing_house_id: this.packing_house_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, packing_house_process.name]"
  ></bread-crumbs>

  <div class="mt-8 flex flex-col" v-if="render_list">
    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      <ul role="list" class="divide-y divide-slate-200">
        <li v-for="(report, index) in quality_template_main_reps" :key="index">
          <div href="#" class="block hover:bg-slate-50 cursor-pointer" @click.prevent="goToShowTemplateRep(report)">
            <div class="px-4 py-4 sm:px-6">
              <div class="flex items-center justify-between">
                <p class="text-sm font-medium text-gray-900 truncate">
                  {{ report.name }}
                </p>
                <div class="ml-2 flex-shrink-0 flex">
                  <a class="link" @click.prevent="goToShowTemplateRep(report)">
                    <i class="fa-solid fa-eye"></i>
                    <span class="space-icon"></span>
                    {{ $t("labels.show_link") }}
                  </a>
                </div>
              </div>

              <div class="mt-2 sm:flex sm:justify-between">
                <div class="sm:flex">
                  <p class="flex items-center text-sm text-gray-500">
                    <i
                      class="fa-solid fa-crate-apple flex-shrink-0"
                      aria-hidden="true"
                    />
                    <span class="space-icon"></span>
                    {{ report.num_quality_inspects }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/quality_reports/process/list_templates.js";

export default {
  name: "ListTemplates",

  props: ["packing_house_id", "packing_house_process_id", "harvested_batch_id"],
  data() {
    return {
      packing_house_process: {},
      harvested_batch: null,
      quality_template_main_reps: [],
      render_list: false,
    };
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id
      });
      this.packing_house_process = response.data;
    },
    fetchQualityTemplateMainReps: async function () {
      let response = await Requester.fetchQualityTemplateMainReps({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id
      });
      this.quality_template_main_reps = response.data;
      this.render_list = true;
    },
    goToShowTemplateRep: function (quality_template_main_rep) {
      this.$router.push({
        name: "ph_quality_reports_process_show_template_rep_path",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          quality_template_main_rep_id: quality_template_main_rep.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id
        }
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchQualityTemplateMainReps();
      })
    );
  }
};
</script>
